export interface FilerEntityUser {
    entityUserId: number;
    filerId: number;
    userId: string;
    userRole: string;
    firstName: string;
    lastName: string;
    email: string;
    statusId: number;
    note?: string;
    pendingMakePrimaryRequest: boolean;
    applicationUserStatusId: number;
}

export interface InvitationDetails {
    type: "join" | "primary" | "new";
    filerId: number;
    filerTypeId: number;
    filerType: string;
    targetName: string;
    entityName: string;
    firstName?: string;
    lastName?: string;
    address1?: string;
    address2?: string;
    stateCode?: string;
    zip?: string;
    city?: string;
    phone?: string;
    expectedUserType?: number;
    role: string;
    expiryDate: Date | string;
    resolved?: boolean;
    email: string;
    token?: string;
}
